var map = {
	"./Clothing.jpg": 456,
	"./Electronics.jpg": 457,
	"./Groceries.jpg": 458,
	"./Household.jpg": 459,
	"./Restaurants.jpg": 460,
	"./Travel.jpg": 461
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 455;